module.exports = __webpack_public_path__ + "static/img/card_3_12.2de678c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_3_12.png
// module id = fqof
// module chunks = 0